<template>
  <b-modal
    id="add-api-key-modal"
    ref="add-api-key-modal"
    cancel-variant="outline-secondary"
    :ok-title="t('Save')"
    :cancel-title="t('Close')"
    centered
    :title="t('Add New Api Key')"
    size="sm"
    @ok="handleOk"
  >
    <b-overlay rounded="md" variant="transparent">
      <validation-observer ref="addApiKeyForm">
        <b-form ref="addApiKeyFormElement">
          <b-row>
            <b-col sm="12">
              <b-form-group :label="t('Start Date')" label-for="start_date">
                <b-input-group class="input-group-merge">
                  <flat-pickr
                    v-model="values.started_at"
                    class="form-control"
                    name="dateFrom"
                    :placeholder="t('Select Date')"
                    :config="{
                      enableTime: false,
                      dateFormat: 'Y-m-d'
                    }"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      icon="XIcon"
                      class="cursor-pointer"
                      @click="values.updated_at = ''"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group :label="t('End Date')" label-for="end_date">
                <b-input-group class="input-group-merge">
                  <flat-pickr
                    v-model="values.expired_at"
                    class="form-control"
                    name="dateFrom"
                    :placeholder="t('Select Date')"
                    :config="{
                      enableTime: false,
                      dateFormat: 'Y-m-d'
                    }"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      icon="XIcon"
                      class="cursor-pointer"
                      @click="values.updated_at = ''"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-checkbox v-model="values.status" name="check-button" switch tabindex="10">
                {{ values.status ? t('Active') : t('Passive') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BOverlay,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend
} from 'bootstrap-vue';
import { helper } from '@core/mixins/helper.js';
import { ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import flatPickr from 'vue-flatpickr-component';
import useService from '@/auth/service/useService';

export default {
  components: {
    BOverlay,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,

    ValidationObserver,

    flatPickr
  },
  mixins: [helper],

  data() {
    return {
      values: {
        started_at: '',
        expired_at: '',
        status: false
      }
    };
  },

  methods: {
    handleOk(bvModalEvent) {
      if (this.submitting) return;

      bvModalEvent.preventDefault();
      this.handleCreate();
    },

    handleCreate() {
      this.$refs.addApiKeyForm.validate().then(success => {
        if (success) {
          useService
            .createApiKey(this.values)
            .then(response => {
              this.showSuccessMessage(`${response.message || this.$t('Api key was created')}`);
              this.$refs['add-api-key-modal'].hide();
              this.$emit('loadItems');
              this.values = {};
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            })
            .finally(() => {});
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
